module.exports = __webpack_public_path__ + "static/img/ff.9bc92fac.png";